import React, { useCallback, useEffect, useState } from "react";
import "./Dropdown.scss";

export const Dropdown = ({
  options = [],
  value = null,
  defaultValue = null,
  onChange = () => {},
  name = "",
  className = "",
  style = {},
}) => {
  const [selected, setSelected] = useState(value);

  useEffect(() => {
    console.log("changing dropdown to", value);
    setSelected(value);
  }, [value]);

  const onValueSelect = useCallback(
    (e) => {
      setSelected(e.target.value);
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <div className={`dropdown ${className}`} style={{ ...style }}>
      <select
        name={name}
        value={selected || defaultValue}
        id=""
        onChange={onValueSelect}
      >
        {options.map((v) => (
          <option value={v} key={`${name}-option-${v}`}>
            {v}
          </option>
        ))}
      </select>
    </div>
  );
};
